/* eslint-disable no-nested-ternary */
import React, { useRef, useCallback, useState } from 'react'
import { FiMail, FiUser, FiSmartphone } from 'react-icons/fi'
import { MdSecurity } from 'react-icons/md'
import { BiFemale, BiCake } from 'react-icons/bi'
import * as Yup from 'yup'
import { Form } from '@unform/web'
import { FormHandles } from '@unform/core'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { Container, Content, BtnModal } from './styles'
import Header from '../../components/Header'
import usePersistedState from '../../hooks/usePersistedState'
import Input from '../../components/Input'
import Button from '../../components/Button'

import InputHidden from '../../components/InputHidden'
import getValidationErrors from '../../utils/getValidationErrors'

import { UserData } from '../../utils/interfaces'
import validaCPF from '../../utils/validaCPF'
import calculaIdade from '../../utils/calculaIdade'
import ModalBox from '../../components/Modal'
import InputSelect from '../../components/InputSelect'

const PersonalInfos: React.FC = () => {
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [, setMenorIdade] = usePersistedState('menorIdade', false)
  const [, setRespLegal] = usePersistedState('respLegal', false)
  const [, setRespFinanceiro] = usePersistedState('respFinanceiro', false)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [sexPartic] = useState({
    label:
      userData.sex === 'F'
        ? 'Feminino'
        : userData.sex === 'M'
          ? 'Masculino'
          : '',
    value: userData.sex,
  })

  const history = useHistory()
  const formRef = useRef<FormHandles>(null)

  const handleClick = useCallback(() => {
    formRef.current?.submitForm()
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleSubmit = useCallback(
    async data => {
      try {
        const aa = data.birthdate
        const dia = aa.split('/')[0]
        const mes = aa.split('/')[1]
        const ano = aa.split('/')[2]
        const dataForm = `${ano}-${`0${mes}`.slice(-2)}-${`0${dia}`.slice(-2)}`

        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          name: Yup.string()
            .required('Seu nome é obrigatório.')
            .matches(/\s/g, 'Digite o nome completo')
            .min(5, 'Digite o nome completo'),
          email: Yup.string()
            .required('E-mail é obrigatório')
            .email('Digite um e-mail válido'),
          phone: Yup.string()
            .max(15, 'Telefone inválido')
            .required('Celular obrigatório'),
          cpf: Yup.string()
            .required('CPF obrigatório')
            .test(
              '',
              'CPF inválido',
              () =>
                validaCPF(data.cpf.replaceAll('.', '').replace('-', '')) ||
                data.cpf === '',
            ),
          birthdate: Yup.string()
            .required('Data de nascimento obrigatória')
            .test(
              '',
              'A data de nascimento não pode ser maior que hoje.',
              () =>
                moment() >
                moment(data.birthdate.split('/').reverse().join('-')) ||
                data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                moment(
                  data.birthdate.split('/').reverse().join('-'),
                ).isValid() || data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                calculaIdade(data.birthdate.split('/').reverse().join('-')) <=
                115 || data.birthdate === '',
            ),
          sexo: Yup.string().required('Sexo obrigatório'),
          parental: Yup.string()
            .required('O nome da mãe é obrigatório.')
            .matches(/\s/g, 'Digite o nome completo')
            .min(5, 'Digite o nome completo'),
        })

        await schema.validate(data, { abortEarly: false })

        await setUserData({
          ...userData,
          name: data.name,
          phone: data.phone,
          email: data.email,
          cpf: data.cpf,
          birthdate: dataForm,
          parental: data.parental,
          sex: data.sexo,
        })

        history.push('/responsible')
      } catch (err) {
        formRef.current?.setErrors(getValidationErrors(err))
      }
    },
    [history, setUserData, userData],
  )

  function handleDataNascimento(e: string) {
    const idade = calculaIdade(e.split('/').reverse().join('-'))
    if (idade < 18) {
      setRespLegal(true)
      setRespFinanceiro(true)
      setMenorIdade(true)
    } else {
      setRespLegal(false)
      setRespFinanceiro(false)
      setMenorIdade(false)
    }
  }

  return (
    <>
      <Header />
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={{
            name: userData.name,
            email: userData.email,
            phone: userData.phone,
            cpf: userData.cpf,
            birthdate:
              userData.birthdate === undefined
                ? ''
                : userData.birthdate.split('-').reverse().join('/'),
            parental: userData.parental,
          }}
        >
          <Content>
            <strong>
              Queremos saber mais sobre você, {userData.name.split(' ')[0]}:
            </strong>
            <InputHidden name="contribution" type="hidden" />
            <Input name="name" placeholder="Nome Completo" icon={FiUser} />
            <Input
              name="phone"
              mask="phone"
              prefix="+55 | "
              placeholder="Seu celular com DDD"
              icon={FiSmartphone}
            />
            <Input
              icon={FiMail}
              name="email"
              type="email"
              placeholder="Seu e-mail pessoal"
            />
            <Input
              placeholder="Digite seu CPF"
              name="cpf"
              icon={MdSecurity}
              type="tel"
              mask="cpf"
              maxLength={11}
            />
            <Input
              icon={BiCake}
              name="birthdate"
              mask="date"
              placeholder="Data de nascimento"
              onBlur={e => handleDataNascimento(e.target.value)}
            />
            <InputSelect
              placeholder="Sexo"
              name="sexo"
              options={[
                { label: 'Feminino', value: 'F' },
                { label: 'Masculino', value: 'M' },
              ]}
              defaultValue={sexPartic}
            />
            <Input
              icon={BiFemale}
              name="parental"
              placeholder="Nome Completo da Mãe"
            />
          </Content>
        </Form>

        <Button type="submit" color="green" onClick={handleClick}>
          Avançar
        </Button>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          <div className="confirmations">
            <p>
              Você confirma que o CPF {userData.cpf} pertence à {userData.name}?
            </p>
            <small>
              *Caso já exista um registro para este CPF e data de nascimento na
              base de dados, o cadastro será atualizado.
            </small>

            <div>
              <BtnModal
                isActive
                onClick={() => {
                  history.push('/responsible')
                  setIsModalOpen(false)
                }}
              >
                Confirmar
              </BtnModal>

              <BtnModal isActive isCancel onClick={() => setIsModalOpen(false)}>
                Cancelar
              </BtnModal>
            </div>
          </div>
        </ModalBox>
      </Container>
    </>
  )
}

export default PersonalInfos
